import { AVAILABILITY_ERROR_CODES } from '@shared/core/availabilities'

export function isCalendarRefusedError(error: unknown): boolean {
  const code = (error as { response?: { data?: { code?: unknown } } })?.response?.data?.code
  return code === AVAILABILITY_ERROR_CODES.CALENDAR_REFUSED
}
